import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import DashboardFilterResource from '@/modules/core/dashboard/resources/DashboardFilterResource';

class DashboardFilterService extends BaseService {
  /**
   * @returns {Promise<void>}
   */
  async getFilterOptions(dashboardId = null) {
    return DashboardFilterResource.getFilterOptions(dashboardId);
  }

  /**
   * @returns {Promise<void>}
   */
  async getFilters() {
    return DashboardFilterResource.getFilters();
  }

  /**
   * @param {DashboardFilters} model
   * @returns {Promise<void>}
   */
  async saveFilters(model) {
    return DashboardFilterResource.saveFilters(model);
  }

  /**
   * @returns {Promise<void>}
   */
  async resetFilters() {
    return DashboardFilterResource.resetFilters();
  }
}

export default new DashboardFilterService();
